import { useEffect, useLayoutEffect } from "react"

export function useVisibleChange(
  cb: (isShow?: boolean) => void,
  immediately?: boolean,
) {
  useLayoutEffect(() => {
    const handleChange = () => {
      cb(document.visibilityState === "visible")
    }
    document.addEventListener("visibilitychange", handleChange)
    return () => {
      document.removeEventListener("visibilitychange", handleChange)
    }
  }, [cb])
  useEffect(() => {
    if (immediately) {
      cb()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
